import { Loader } from '@grafikr/components';

import regions from 'framework/regions';

export default Loader(async (_, load) => {
  const getCurrentSite = regions.getCurrentLocale();
  const [shouldShowPrompt, getIntendedSite] = await Promise.all([
    regions.shouldShowPrompt(),
    regions.getIntendedSite(),
  ]);

  if (shouldShowPrompt && getCurrentSite.locale !== getIntendedSite.locale) {
    load();
  }
});
